module.exports = require("@toruslabs/torus-embed");